import { Component, HostListener, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { FileServiceService } from '../service/file-service.service';
import { FileCaptureService, ValidateReferralResponse } from '../service/file-capture.service';
import { NgxSpinnerService } from 'ngx-spinner'
import { ProgressService } from 'app/service/progress.service';
import { AuthService } from 'app/service/auth-service';
import { switchMap } from 'rxjs';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  error: boolean = false;
  errorMessage: string = '';
  private readonly MSG_INVALID = 'The Reference ID entered is not valid, please click on the Clear button and try again.';
  private readonly MSG_IN_USE = 'Please use a different Reference ID as this one is currently being used by another user.';
  progressMessage: string;
  referenceForm: FormGroup = new FormGroup({
    referenceNumber: new FormControl('', [Validators.required, Validators.maxLength(60)])
  });
  isUrlDisabled: boolean = true;
  securityCode: any;
  showLoader: boolean = true;
  payorKey: number;
  // <LLM_CODE_BEGIN story="US_826609">
  fileCaptureConfig: any = null;
  // <LLM_CODE_END story="US_826609">

  constructor(private route: Router, private service: FileServiceService,
    private fcservice: FileCaptureService, private ngxspinner: NgxSpinnerService, private authService: AuthService,
    private router: Router) {
    this.ngxspinner.show();
    this.securityCode = router.url.replace("/", "");
    this.authService.setIsLoggedIn(false);
  }

  ngOnInit() {
    const refId = this.service.referenceFileDetails.referenceId || '';

    this.referenceForm.get('referenceNumber')?.setValue(refId);
    // <LLM_CODE_BEGIN story="US_826609">
    // Load FileCapture config to check if instructions are enabled
    this.fcservice.getFileCaptureConfig(this.securityCode).subscribe(
      (config) => {
        this.fileCaptureConfig = config;
        const instructionEnabled = !!(config && config.InstructionEnabled);
        const instruction = config?.Instruction || config?.instruction || '';
        const formattedInstruction = instruction ? instruction.replace('<img ', '<img title="Header" ') : '';
        window.localStorage.setItem('fc_instruction_enabled', String(instructionEnabled));
        window.localStorage.setItem('fc_instruction_text', formattedInstruction);
        this.showLoader = false;
        this.ngxspinner.hide();
        if (config == null || config.PayorKey == null || config.UrlStatus != 1) {
          this.isUrlDisabled = true;
          return;
        }
        this.payorKey = config.PayorKey;
        window.sessionStorage.setItem(this.fcservice.PAYOR_KEY, String(this.payorKey));
        window.localStorage.setItem('securityCode', this.securityCode);
        this.isUrlDisabled = false;
      },
      (error) => {
        console.error('Error loading FileCapture config:', error);
      }
    );
    // <LLM_CODE_END story="US_826609">    
  }



  private releaseLock(referenceId?: string | null, sessionId?: string | null) {
    const refId = referenceId || this.service.referenceFileDetails.referenceId || this.service.getCache('referenceId');
    return this.fcservice.releaseActiveReferenceLock(this.payorKey, refId, sessionId);
  }

  @HostListener('window:beforeunload')
  onBeforeUnload(): void {
    this.releaseLock().subscribe();
  }

  clear() {
    this.releaseLock().subscribe();
    this.referenceForm.get('referenceNumber')?.setValue('');
    this.error = false;
    this.errorMessage = '';
  }

  Next() {
    this.ngxspinner.show();
    this.error = false;
    this.errorMessage = '';
    const nextReferenceId = this.referenceForm.get('referenceNumber')?.value || '';
    const previousReferenceId = this.service.referenceFileDetails.referenceId || this.service.getCache('referenceId');
    const previousSessionId = window.sessionStorage.getItem(this.fcservice.SESSION_KEY) || '';

    this.releaseLock(previousReferenceId, previousSessionId).pipe(
      switchMap(() => {
        this.service.reset();
        this.service.clearVisitedPages();
        this.service.authenticatedEmail = null;
        this.fcservice.fileArray = [];
        this.service.setCacheForitems([
          { id: 'attachmentSaved', value: null },
          { id: 'caseActivityKey', value: null },
          { id: 'attachmentSavedForRef', value: null },
          { id: 'files', value: null }
        ]);

        this.service.referenceFileDetails.referenceId = nextReferenceId;
        this.service.setCacheForitems([{ id: 'referenceId', value: nextReferenceId }]);

        return this.fcservice.getReferenceId(nextReferenceId, this.payorKey, '');
      })
    ).subscribe((res: ValidateReferralResponse) => {
      this.ngxspinner.hide();
      if (res?.sessionId) {
        this.fcservice.setActiveReferenceSession(nextReferenceId, res.sessionId);
      }
      const isValid = res?.isValid === true;
      const isInUse = res?.isInUse === true;

      if (isInUse) {
        this.error = true;
        this.errorMessage = this.MSG_IN_USE;
        return;
      }

      if (isValid) {
        this.route.navigate(['reference']);
      } else {
        this.error = true;
        this.errorMessage = this.MSG_INVALID;
      }
    }, () => { this.ngxspinner.hide(); });
  }
}
